module.exports = __webpack_public_path__ + "img/man_1_1.c1717c46.png";